import { NetworkClient, useClassFactory, useNetworkService } from "@pasta/box-v2";

export class UpstreamApi {
  getBaseEndpoint(letterFileId: number) {
    return `letter-file/${letterFileId}/upstream/`;
  }

  protected get network(): NetworkClient {
    return useNetworkService();
  }

  async seeAgain(lfId: number, upstreamId: number) {
    await this.network.post(`${this.getBaseEndpoint(lfId)}${upstreamId}/see-again`);
  }
}

export const [upstreamApiToken, useUpstreamApi] = useClassFactory(UpstreamApi);
